import { INVISIBLES } from '@workspace/constants/common.constant';

export const getTextAlignClasses = (textAlign: string) => {
  const cleanTextAlign = typeof textAlign === 'string' ? textAlign.replace(INVISIBLES, '').trim() : 'left';

  switch (cleanTextAlign) {
    case 'center':
      return 'text-center';
    case 'right':
      return 'text-right';
    default:
      return 'text-left';
  }
};

export const getColumnClasses = (layout: string) => {
  switch (layout) {
    case 'two-column':
      return 'grid grid-cols-1 lg:grid-cols-2';
    default:
      return '';
  }
};
